enum Path {
    HOME = '/maintenance/sorry',
}

export default Path